import dayjs from "dayjs";
import { get } from "lodash";
import moment from "moment";
import toast from "react-hot-toast";

import { routingConstants } from "@/Constants/routingConstants";

import { apiDecrypt, apiEncrypt } from "./keyEncryption";
import { AGENCY_API_V6_DEVELOPMENT_URL } from "../Constants/common";
import { loadState, _localGet, _localRemove, _localSet } from "../localStorage";
// import { useSelector } from "react-redux";

// const { user } = useSelector((state) => state.clientProfile);

/**
 * Verify an object and return the specified parameter or a default value if not found.
 *
 * @param {object} obj - The object to verify
 * @param {string} param - The parameter to retrieve from the object
 * @param {any} defaultValue - The default value to return if the parameter is not found
 * @return {any} The value of the specified parameter or the default value
 */
export const verifyObject = (obj, param, defaultValue) => {
  let data = get(obj, param, defaultValue);
  return data;
};

export const markerLate = ["marker"];

/**
 * Returns the class names for text color and background based on the input miles.
 *
 * @param {number} miles - The number of miles
 * @return {object} An object containing color, bg, and cls properties
 */
export const getMilesClass = (miles) => {
  let color = "";
  let bg = "";
  if (miles >= 0 && miles <= 3) {
    color = "text-miles_one_color";
    bg = "bg-miles_one_bg";
  } else if (miles > 3 && miles <= 6) {
    color = "text-miles_two_color";
    bg = "bg-miles_two_bg";
  } else if (miles > 6 && miles <= 9) {
    color = "text-miles_three_color";
    bg = "bg-miles_three_bg";
  } else if (miles > 9 && miles <= 12) {
    color = "text-miles_four_color";
    bg = "bg-miles_four_bg";
  } else if (miles > 12 && miles <= 18) {
    color = "text-miles_five_color";
    bg = "bg-miles_five_bg";
  } else if (miles > 18 && miles <= 24) {
    color = "text-miles_six_color";
    bg = "bg-miles_six_bg";
  } else {
    color = "text-miles_seven_color";
    bg = "bg-miles_seven_bg";
  }
  let cls = `${color} ${bg}`;
  return { color, bg, cls };
};

/**
 * Format the given time to HH:mm.
 *
 * @param {string} time - the time to format
 * @param {string} existingFormat - the format of the input time
 * @return {string} the formatted time in HH:mm format
 */
export const commonFormatTime = (time, existingFormat) => {
  if (time === null || time === undefined || time === "" || time === "-") {
    return "00:00";
  } else {
    return moment(time, existingFormat).format("HH:mm");
  }
};

/**
 * Displays a success toast message with the given message and options.
 *
 * @param {string} message - The message to be displayed in the toast
 * @param {object} options - An optional object containing additional options for the toast
 * @return {void}
 */
export const showSuccessToast = (message, options = {}) => {
  return toast.success(message, {
    ...options,
    className:
      " bg-white font-openSans font-medium text-base leading-[20px] !text-green border border-green",
    duration: options.duration || 5000,
  });
};

/**
 * Show an error toast with the given message and options.
 *
 * @param {string} message - The message to display in the error toast
 * @param {object} options - Additional options for customizing the error toast
 * @return {any} The result of displaying the error toast
 */
export const showErrorToast = (message, options = {}) => {
  if (message == "Unauthorized") {
    return;
  }
  let cls = options?.cls || "";
  return toast.error(message, {
    ...options,
    className: `bg-white font-medium text-base leading-[20px] !text-red border border-red ${cls}`,
    duration: options?.duration || 5000,
  });
};

/**
 * Show a warning toast with the given message and options.
 *
 * @param {string} message - The message to display in the toast
 * @param {object} options - The options for customizing the toast (optional)
 * @return {any} The result of displaying the toast
 */
export const showWarningToast = (message, options = {}) => {
  return toast(message, {
    ...options,
    className:
      "bg-white font-medium text-base leading-[20px] !text-yellow border border-yellow",
    duration: options?.duration || 5000,
  });
};

/**
 * Displays a common toast message with the given message and options.
 *
 * @param {string} message - The message to be displayed in the toast.
 * @param {object} options - The options for customizing the toast (optional).
 * @return {any} The result of the toast function.
 */
export const showCommonToast = (message, options = {}) => {
  return toast(message, {
    ...options,
    className:
      "bg-white font-openSans font-medium !text-[14px] leading-[20px] !text-primary border border-primary",
    duration: options.duration || 5000,
  });
};

/**
 * Displays a confirmation toast with the specified content and options.
 *
 * @param {string} content - the content to be displayed in the toast
 * @param {Object} options - optional configuration options for the toast
 * @return {Object} the generated toast object
 */
export const showConfirmToast = (content, options = {}) => {
  return toast(content, {
    ...toast,
    className:
      "bg-white font-openSans font-medium !text-[14px] leading-[20px] border-2 !border-primary bg-lightblueBG ",
    duration: 500000,
    id: "confirmToast",
  });
};

export const showManagedServiceToast = (message, options = {}) => {
  return toast(
    "To utilise this feature you need to be on AppConnect+ (Self Service). Please contact your AppLocum consultant to discuss this further.",
    {
      ...options,
      className:
        "bg-white font-openSans font-medium text-base leading-[20px] !text-black border-2 border-primary",
      dismiss: "click",
      position: "top-center",
      id: "managedServiceToast",
    },
  );
};

export const showCandidateSixMonthDurationToast = (message, options = {}) => {
  return toast(" if candidate haven't worked with client for last 6 months", {
    ...options,
    className:
      "bg-white font-openSans font-medium text-base leading-[20px] !text-black border-2 border-primary",
    dismiss: "click",
    position: "top-center",
    id: "managedServiceToast",
  });
};

export const showRoleAccessToast = (message, options = {}) => {
  return toast(
    "Restricted Access, Please contact your administrator for access",
    {
      ...options,
      className:
        "bg-white font-openSans select-none font-medium text-base leading-[20px] !text-red border-2 border-red",
      dismiss: "click",
      position: "top-center",
      id: "managedRoleAccessToast",
    },
  );
};

/**
 * Display a toast for the given promise with customizable options.
 *
 * @param {Promise} promise - The promise to display the toast for.
 * @param {Object} options - Customizable options for the toast.
 * @return {Promise} A promise that resolves when the toast is finished displaying.
 */
export const showPromiseToast = (promise, options = {}) => {
  return toast.promise(
    promise,
    {
      ...options,
    },
    {
      duration: options.duration || 5000,
      loading: {
        className:
          "bg-white font-openSans font-medium !text-[14px] leading-[20px] border border-primary !text-blue",
      },
      success: {
        className:
          "bg-white font-openSans font-medium !text-[14px] leading-[20px] !text-green border border-green",
      },
      error: {
        className:
          "bg-white font-openSans font-medium !text-[14px] leading-[20px] !text-red border border-red",
      },
    },
  );
};

// to check if filter is applied or not on a listing by given filters
export const getIsFilterApplied = (filters) => {
  return Object.values(filters).some(
    (item) =>
      item !== "" &&
      item !== null &&
      (Array.isArray(item) ? item.length > 0 : true),
  );
};

/**
 * Calculate the compliance class based on the percentage.
 *
 * @param {number} percentage - The percentage value
 * @return {string} The compliance class
 */
export const getComplianceClass = (percentage) => {
  if (percentage <= 50 || percentage == null || percentage == "-") {
    return "bg-red-100 text-red border border-red";
  } else if (percentage > 51 && percentage < 100) {
    return "bg-yellow-200 text-yellow border border-yellow";
  } else if (percentage == 100) {
    return "bg-green-200 text-green border border-green";
  }
};

export const candidateGetComplianceClass = (percentage) => {
  if (percentage <= 50 || percentage == null || percentage == "-") {
    return "text-red";
  } else if (percentage > 51 && percentage < 100) {
    return "text-yellow";
  } else if (percentage == 100) {
    return "text-green";
  }
};

export const isKeyUpValid = (key) => {
  let isNumber = /^\d+$/.test(key);
  if (
    !isNumber &&
    key !== "Backspace" &&
    key !== "Delete" &&
    key !== "ArrowLeft" &&
    key !== "ArrowRight" &&
    key !== "ArrowUp" &&
    key !== "ArrowDown" &&
    key !== ":" &&
    key !== "Tab" &&
    key !== "Home" &&
    key !== "End"
  ) {
    return true;
  } else {
    return false;
  }
};

export const validateTimeFormat = (time) => {
  if (dayjs(time, "HH:mm", true).isValid()) {
    return true;
  }
  return false;
};

/**
 * Escapes special characters in HTML.
 *
 * @param {string} text - The text to escape
 * @return {string} The escaped text
 */
export const escapeHtml = (text) => {
  var map = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#039;",
  };
  return text.replace(/[&<>"']/g, function (m) {
    return map[m];
  });
};

export const isDateBetween = (date, startDate, endDate) => {
  let format = "DD-MM-YYYY";
  return moment(date, format).isBetween(
    moment(startDate, format),
    moment(endDate, format),
    undefined,
    "[]",
  );
};

export const getWorkedStatusClasses = (stts) => {
  let status = stts ? stts.toLowerCase() : stts;
  let obj = {
    authorised: "border border-primary bg-white !text-primary",
    Authorized: "border border-primary bg-white !text-primary",
    invoiced: "border border-green bg-white !text-green",
    pending: "border border-yellow bg-white !text-yellow",
    terminated: "border border-orange bg-white !text-orange",
    rejected: "border border-red bg-white !text-red",
    assigned: "border border-pink bg-white !text-pink",
    worked: "border border-primary bg-white !text-primary",
    booked: "border border-green bg-white !text-green",
  };
  return obj[status];
};

export const handleAPICatch = (error) => {
  // const { error, callback = null, errorId = "_error" } = obj;
  if (error instanceof ReferenceError) {
    showErrorToast(`Something went wrong \n ${error.message}`, {
      id: "errorId",
    });
    console.error("ReferenceError caught:", error.message);
    return;
  }
  if (error?.name === "CanceledError") {
    return;
  }
  // Silently suppress 404 (API endpoint not found) errors
  if (error?._suppressed404 || error?.response?.status === 404) {
    return;
  }
  const message = error?.response?.data?.message || error?.message || "";
  const statusText = error?.response?.statusText || "Something went wrong";

  let errorMessage = message ?? statusText;
  console.error("API Error:", errorMessage);
  if (errorMessage.toString().includes("SQLSTATE")) {
    errorMessage = "Something went wrong !!";
  }
  showErrorToast(errorMessage, {
    id: errorMessage.toString(),
  });

  // callback && callback();
};
export const _chatTemplatePlaceholder = [
  "candidate_ref_no",
  "candidate_full_name",
  "candidate_title",
  "candidate_firstname",
  "candidate_lastname",
  "candidate_email",
];

export const isBranchLink = (url) => {
  var branchDomains = ["app.link", "test-app.link"]; // Add your custom domains here
  var urlHostname = new URL(url).hostname;
  for (var i = 0; i < branchDomains.length; i++) {
    if (urlHostname.endsWith(branchDomains[i])) {
      return true;
    }
  }
  return false;
};

export const formatLatestUpdateForAnnouncement = (message) => {
  if (!message) return "";

  // Split the message by line breaks
  const lines = message
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter((line) => line);

  // Process lines and add bullet points for regular lines
  const formattedLines = lines.map((line) => {
    if (line.startsWith("<h1>")) {
      // Customize <h1> styles and make sure it's only applied to the specific part
      return line
        .replace(
          "<h1>",
          '<h1 style="font-size: 16px; font-weight: 600; color: #2843df;line-height:25px;text-transform: capitalize;margin:10px 0px">',
        )
        .replace(
          "</h1>",
          '</h1><li style="font-size: 14px; font-weight: 500; line-height: 27px;">',
        ); // Ensure the closing tag is respected
    } else if (line.startsWith("<b>")) {
      // Customize <b> styles
      return line.replace("<b>", '<b style="font-weight: bold;">');
    } else {
      // Add bullet points for regular lines
      return `<li style="font-size: 14px; font-weight: 500; line-height: 27px;">• ${line}</li>`;
    }
  });

  // Join the formatted lines into a list
  return `<ul>${formattedLines.join("")}</ul>`; // Wrap all lines in <ul>
};

export const getNotificationLink = (type, encrypted_id, link) => {
  const obj = {
    overdue_invoice: routingConstants.invoice,
    authorise_timesheet: routingConstants.workedCandidate,
    authorised_timesheet: routingConstants.workedCandidate,
    job_application: routingConstants.contractDetail(encrypted_id),
    expired_document: routingConstants.candidateDetail(encrypted_id),
    candidate_running_late: routingConstants.contractDetail(link),
    candidate_terminated_shifts_client:
      routingConstants.contractDetail(encrypted_id),
  };

  if (obj[type] && encrypted_id !== "-") {
    return obj[type];
  } else {
    return routingConstants.dashboard;
  }
};

export const getSubscriptionId = () => {
  const initialState = loadState();
  const session = initialState.session.session;
  const { subscription_id } = session;
  return subscription_id;
};

export const isPremiumUser = () => {
  return getSubscriptionId() == 2; // 2 is premium subscription and 1 is managed subscription
};

export const systemAllRequests = (obj) => {
  const { request, page, route, method } = obj;
  if (_localGet(page + "_reqData")) {
    _localRemove(page + "_reqData");
  }
  _localSet(page + "_reqData", apiEncrypt(JSON.stringify(obj)));
};

export const getSystemAllRequests = (data, defaultAction = "") => {
  let candidateIds = data.candidate_ids;
  let isSelectedAll = data.isSelectedAll;
  let ignoreIds = data.ignoreIds;
  let action = defaultAction;
  let reason = data.reason;

  if (data.action) {
    action = data.action;
  }
  if (defaultAction == "unsuitable") {
  }
  let page = data.page;

  // console.log(page + "_reqData")
  let postData = _localGet(page + "_reqData");
  postData = JSON.parse(apiDecrypt(postData));
  let allRequest = postData.request;
  for (let key in allRequest) {
    postData[key] = allRequest[key];
  }
  postData.action = action;
  if (isSelectedAll) {
    postData.ignoreIds = ignoreIds;
  } else {
    postData.candidate_ids = candidateIds;
  }
  if (defaultAction == "unsuitable") {
    postData.reason = reason;
  }
  return postData;
};

export const getSystemAllRequestsForExport = (data, _key, value) => {
  let isSelectedAll = data.isSelectedAll;
  let ignoreIds = data.ignoreIds;
  let page = data.page;
  // console.log("page===========",page)
  let postData = _localGet(page + "_reqData");
  if (postData) {
    postData = JSON.parse(apiDecrypt(postData));
    let allRequest = postData.request;
    for (let key in allRequest) {
      postData[key] = allRequest[key];
    }
    if (isSelectedAll) {
      postData.ignoreIds = ignoreIds;
    } else {
      postData[_key] = value;
    }
    return postData;
  }
};

export const getFullUrl = (_endPoint) => {
  const fullURL = `${AGENCY_API_V6_DEVELOPMENT_URL}${_endPoint}`;
  return fullURL;
};

export const viewHelpYoutubeVideo = [
  {
    label: "Contact Us",
    ytLink: "",
    mainHeading: "Contact",
  },
  {
    label: "Report/Feedback",
    ytLink: "",
    mainHeading: "Contact",
  },
  {
    label: "How to Login",
    ytLink: "https://www.youtube.com/watch?v=ST_nxUdVn0A",
    mainHeading: "Guide videos",
  },
  {
    label: "Main Dashboard",
    ytLink: "https://www.youtube.com/watch?v=gLBOTbb8sK4",
    mainHeading: "Guide videos",
  },
  {
    label: "Booked Module",
    ytLink: "https://www.youtube.com/watch?v=rTe2LCZDH6A",
    mainHeading: "Guide videos",
  },
  {
    label: "Worked Module",
    ytLink: "https://www.youtube.com/watch?v=xAx_flHJbbo",
    mainHeading: "Guide videos",
  },
  {
    label: "Contract Details",
    ytLink: "https://www.youtube.com/watch?v=QnNxWKmcB6w",
    mainHeading: "Guide videos",
  },
  {
    label: "Candidate Details",
    ytLink: "https://www.youtube.com/watch?v=HVVLF6qLWH8",
    mainHeading: "Guide videos",
  },

  {
    label: "Compliance Management",
    ytLink: "https://www.youtube.com/watch?v=NOcajDdlbSo",
    mainHeading: "Guide videos",
  },

  {
    label: "Invite Module",
    ytLink: "https://www.youtube.com/watch?v=vqYAlziKiws",
    mainHeading: "Guide videos",
  },

  {
    label: "Branch Management",
    ytLink: "https://www.youtube.com/watch?v=UXQ48eMysNk",
    mainHeading: "Guide videos",
  },

  {
    label: "User & Role Based Access",
    ytLink: "https://www.youtube.com/watch?v=2Siz6AQqxzY",
    mainHeading: "Guide videos",
  },

  {
    label: "My Profile Section",
    ytLink: "https://www.youtube.com/watch?v=Z69FweCalR0",
    mainHeading: "Guide videos",
  },
];

export const ComplianceStatusList = [
  {
    name: "Approved",
    value: "Approved",
  },
  {
    name: "Rejected",
    value: "Rejected",
  },
  {
    name: "Awaiting Approval",
    value: "Awaiting Approval",
  },
];

/**
 * Handles the key up event for a time picker input field.
 *
 * @param {Object} e - The event object.
 * @param {Object} e.target - The target element of the event.
 * @param {string} e.target.value - The current value of the input field.
 * @param {string} e.key - The key that was pressed.
 */
export const handleKeyUpForTimePicker = (e) => {
  let value = e.target.value;
  if (e.key === "Backspace") {
    if (value.length === 2) {
      e.target.value = value.slice(0, 1);
    }
  } else {
    if (value.length === 2) {
      e.target.value = value + ":";
    }
  }
};

/**
 * Get the compliance status class based on the status title.
 *
 * @param {string} statusTitle - The title of the compliance status
 * Possible values: "approved", "not uploaded", "rejected", "not applicable", "awaiting approval"
 * @return {string} The compliance status class
 */
export const getComplianceStatusClass = (statusTitle) => {
  let status = statusTitle.toLowerCase();
  if (status === "approved") {
    return "max-w-[95px]  bg-green-100 text-green border border-green ";
  } else if (status === "not uploaded" || status === "rejected") {
    return "max-w-[105px]  bg-red-100 text-red border border-red";
  } else if (status === "not applicable") {
    return "min-w-[75px]  bg-yellow-100 text-yellow border border-yellow";
  } else if (status === "awaiting approval") {
    return "max-w-[120px]  bg-yellow-100 text-yellow border border-yellow";
  }
};
